<template>
  <card>
    <div>
        <div v-if="loading" class="text-center py-5">
          <div class="loading-container">
            <div class="emoji-container mb-3">
              <span class="emoji animate-bounce h2" role="img" aria-label="Car">🚗</span>
              <span class="emoji animate-pulse h2" role="img" aria-label="Hourglass">⏳</span>
              <span class="emoji animate-bounce h2" role="img" aria-label="Thinking">🤔</span>
            </div>
            <span class="font-weight-bold text-primary h2">Obteniendo información...</span>
            <p class="loading-message text-muted">
              Espere un momento mientras preparamos los datos.
            </p>
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
          </div>
        </div>

      <!-- Navegación de pasos -->
      <div class="row justify-content-center text-center pt-4 pb-2 bg-dark rounded-pill m-2" v-if="!loading">
        <div class="row col-xl-2 col-md-2 col-sm-6 offset-sm-0 flex-nowrap justify-content-center">
          <div class="p-2">
            <button class="btn-evaluacion btn btn-circle btn-secondary" :class="paso == 1 ? 'active' : ''"
              :disabled="loading" @click="cambiarPaso(1)">
              <span class="h3">1</span>
            </button>
            <p class="pt-3 h4">Pruebas Alcoholimetria</p>
          </div>
          <div class="p-2">
            <button class="btn-evaluacion btn btn-circle btn-secondary" :class="paso == 2 ? 'active' : ''"
              :disabled="loading" @click="cambiarPaso(2)">
              <span class="h3">2</span>
            </button>
            <p class="pt-3 h4">Exámenes Médicos</p>
          </div>
          <div class="p-2">
            <button class="btn-evaluacion btn btn-circle btn-secondary" :class="paso == 3 ? 'active' : ''"
              :disabled="loading" @click="cambiarPaso(3)">
              <span class="h3">3</span>
            </button>
            <p class="pt-3 h4">Exámenes Aptitud Física</p>
          </div>
        </div>
      </div>

      <!-- Tabla de datos -->
      <div class="px-4 mt-3" v-if="!loading && listaItems && listaItems.length > 0">
        <div class="table-responsive">
          <table id="datatable_examenes" class="table table-bordered table-striped text-center" style="width: 100%">
            <!-- Headers y body para paso 1 -->
            <thead v-if="paso == 1">
              <tr>
                <th>Código Prueba</th>
                <th>Código Dispositivo</th>
                <th>Tipo Identificación</th>
                <th>Número Identificación</th>
                <th>Fecha Prueba</th>
                <th>Hora Prueba</th>
                <th>Resultado</th>
                <th>Grado</th>
                <th>Fecha Creación</th>
                <th>Fecha Actualización</th>
              </tr>
            </thead>
            <tbody v-if="paso == 1">
              <tr v-for="(item, index) in listaItems" :key="`paso1-${index}`" class="animated-row">
                <td>{{ item.codigoPrueba || '—' }}</td>
                <td>{{ item.codigoDispositivo || '—' }}</td>
                <td>{{ item.tipoIdentificacion || '—' }}</td>
                <td>{{ item.numeroIdentificacion || '—' }}</td>
                <td>{{ formatFecha(item.fechaPrueba) }}</td>
                <td>{{ item.horaPrueba || '—' }}</td>
                <td>
                  <span class="badge" :class="{
                    'badge-success': ['negativo', 'negative'].includes((item.resultado || '').toLowerCase()),
                    'badge-danger': ['positivo', 'positive', 'aprobado'].includes((item.resultado || '').toLowerCase()),
                    'badge-secondary': !item.resultado
                  }">
                    {{ item.resultado || 'Sin resultado' }}
                  </span>
                </td>
                <td>{{ item.grado || '—' }}</td>
                <td>{{ formatFecha(item.created_at) }}</td>
                <td>{{ formatFecha(item.updated_at) }}</td>
              </tr>
            </tbody>

            <!-- Headers y body para paso 2 -->
            <thead v-if="paso == 2">
              <tr>
                <th>Tipo Identificación</th>
                <th>Número Identificación</th>
                <th>Fecha Examen</th>
                <th>Hora Examen</th>
                <th>Resultado</th>
              </tr>
            </thead>
            <tbody v-if="paso == 2">
              <tr v-for="(item, index) in listaItems" :key="`paso2-${index}`" class="animated-row">
                <td>{{ item.tipoIdentificacion || '—' }}</td>
                <td>{{ item.numeroIdentificacion || '—' }}</td>
                <td>{{ formatFecha(item.fechaExamen) }}</td>
                <td>{{ item.horaExamen || '—' }}</td>
                <td>
                  <span class="badge" :class="{
                    'badge-success': ['apto'].includes((item.resultado || '').toLowerCase()),
                    'badge-danger': ['no apto', 'rechazado'].includes((item.resultado || '').toLowerCase()),
                    'badge-secondary': !item.resultado
                  }">
                    {{ item.resultado || 'Sin resultado' }}
                  </span>
                </td>
              </tr>
            </tbody>

            <!-- Headers y body para paso 3 -->
            <thead v-if="paso == 3">
              <tr>
                <th>Tipo Identificación</th>
                <th>Número Identificación</th>
                <th>Fecha Examen</th>
                <th>Hora Examen</th>
                <th>Resultado</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody v-if="paso == 3">
              <tr v-for="(item, index) in listaItems" :key="`paso3-${index}`" class="animated-row">
                <td>{{ item.tipoIdentificacion || '—' }}</td>
                <td>{{ item.numeroIdentificacion || '—' }}</td>
                <td>{{ formatFecha(item.fechaExamen) }}</td>
                <td>{{ item.horaExamen || '—' }}</td>
                <td>
                  <span class="badge" :class="{
                    'badge-success': ['apto'].includes((item.resultado || '').toLowerCase()),
                    'badge-danger': ['no apto', 'rechazado'].includes((item.resultado || '').toLowerCase()),
                    'badge-secondary': !item.resultado
                  }">
                    {{ item.resultado || 'Sin resultado' }}
                  </span>
                </td>
                <td class="px-3">
                  <div class="d-flex justify-content-center">
                    <vs-button success v-b-tooltip="{
                      title: 'Editar examen',
                      placement: 'top',
                      customClass: 'font_tooltip',
                    }" @click.prevent="abrirModalEditar(item)" icon>
                      <i class="fa-solid fa-pen"></i>
                    </vs-button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Mensaje cuando no hay datos -->
      <div v-if="!loading && (!listaItems || listaItems.length === 0)" class="text-center py-5">
        <div class="empty-state">
          <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
          <h4 class="text-muted">No hay datos disponibles</h4>
          <p class="text-muted">No se encontraron registros para el examen.</p>
        </div>
      </div>

      <!-- Modal para editar exámenes -->
      <b-modal ref="modalEditarExamenes" size="xl" hide-footer hide-header body-class="bg-dark">
        <formularioAptitudFisica :tipo-identificaciones="tipoIdentificaciones" :results-exams="resultsExams"
          @submit="actualizarPrueba" :preCarga="examenAptitudFisica" class="bg-dark rounded" />
      </b-modal>
    </div>
  </card>
</template>

<script>
import formularioAptitudFisica from '../examenes/formulario-aptitud-fisica.vue';
import Swal from 'sweetalert2';

export default {
  data() {
    return {
      paso: 1,
      listaItems: [],
      persona: null,
      loading: true,
      dataTableInstance: null,
      tipoIdentificaciones: null,
      resultsExams: [
        { label: 'Aprobado', value: 'aprobado' },
        { label: 'No Aprobado', value: 'no_aprobado' },
        { label: 'Pendiente', value: 'pendiente' }
      ],
      examenAptitudFisica: null
    };
  },
  components: {
    formularioAptitudFisica
  },
  async mounted() {
    try {
      this.persona = JSON.parse(localStorage.getItem("setPersonaAct"));
      await this.obtenerTiposIdentificacion();
      await this.getData(1);
    } catch (error) {
      console.error('Error en mounted:', error);
      this.lanzarAlerta('error', 'Error', 'Error al cargar los datos iniciales');
    }
  },
  beforeDestroy() {
    this.destroyDataTable();
  },
  methods: {
    async cambiarPaso(nuevoPaso) {
      if (this.paso === nuevoPaso || this.loading) return;

      this.loading = true;
      await this.getData(nuevoPaso);
    },

    async getData(paso) {
      try {
        this.loading = true;
        this.paso = paso;

        // Destruir DataTable existente
        this.destroyDataTable();

        // Limpiar datos anteriores
        this.listaItems = [];

        let res = null;
        const endpoints = {
          1: "ApiSuperTransporteTerminales/ObtenerAlcoholimetria",
          2: "ApiSuperTransporteTerminales/ObtenerExamen-medico",
          3: "ApiSuperTransporteTerminales/ObtenerAptitud-medico"
        };

        if (endpoints[paso]) {
          res = await this.$store.dispatch("hl_get_cookie", {
            path: endpoints[paso],
          });
        } else {
          throw new Error("Paso no válido");
        }

        console.log(`Resultado del paso ${paso}:`, res);

        if (res && res.datos && Array.isArray(res.datos)) {
          this.listaItems = res.datos;
        } else {
          this.listaItems = [];
          console.log(`No se encontraron datos para el paso ${paso}.`);
        }
      } catch (error) {
        console.error(`Error al obtener datos del paso ${paso}:`, error);
        this.listaItems = [];
        this.lanzarAlerta('error', 'Error', `Error al cargar los datos del paso ${paso}`);
      } finally {
        this.loading = false;
        // Esperar a que Vue actualice el DOM
        await this.$nextTick();

        // Inicializar DataTable después de que los datos estén cargados
        if (this.listaItems.length > 0) {
          this.initializeDataTable();
        }        
      }
    },

    initializeDataTable() {

      this.$nextTick(() => {
        try {
          // Verificar que el elemento existe y tiene datos
          const tableElement = document.getElementById('datatable_examenes');
          if (!tableElement || this.listaItems.length === 0) {
            return;
          }

          // Destruir instancia existente si existe
          this.destroyDataTable();

          // Crear nueva instancia de DataTable
          this.dataTableInstance = window.$("#datatable_examenes").DataTable({
            language: {
              url: "//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json",
            },
            responsive: true,
            destroy: true,
          });

          console.log('DataTable inicializado correctamente para paso:', this.paso);
        } catch (error) {
          console.error('Error al inicializar DataTable:', error);
        }
      });
    },

    destroyDataTable() {
      try {
        if (this.dataTableInstance) {
          this.dataTableInstance.destroy();
          this.dataTableInstance = null;
        } else if (window.$.fn.DataTable.isDataTable("#datatable_examenes")) {
          window.$("#datatable_examenes").DataTable().destroy();
        }
      } catch (error) {
        console.error('Error al destruir DataTable:', error);
      }
    },

    formatFecha(fecha) {
      if (!fecha) return "—";
      try {
        const f = new Date(fecha);
        if (isNaN(f.getTime())) return "—";
        return f.toLocaleDateString("es-CO", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      } catch (error) {
        console.error('Error al formatear fecha:', error);
        return "—";
      }
    },

    async obtenerTiposIdentificacion() {
      try {
        const response = await this.$store.dispatch('hl_get_cookie', {
          path: 'ApiSuperTransporteGenerales/listar-tipo-identificaciones'
        });

        if (Array.isArray(response)) {
          this.tipoIdentificaciones = response.filter(item => item.estado === true);
        } else {
          console.warn('Formato de respuesta inesperado:', response);
          this.tipoIdentificaciones = [];
        }
      } catch (error) {
        console.error('Error al obtener tipos de identificación:', error);
        this.lanzarAlerta('error', 'Error', 'Error al cargar tipos de identificación');
        this.tipoIdentificaciones = [];
      }
    },

    async actualizarPrueba(item) {
      try {
        if (!this.examenAptitudFisica || !this.examenAptitudFisica.codigoExamen) {
          throw new Error('No se ha seleccionado un examen válido');
        }

        const data = {
          "tipoIdentificacion": item.tipoIdentificacion,
          "numeroIdentificacion": item.numeroIdentificacion,
          "fechaExamen": item.fechaExamen,
          "horaExamen": item.horaExamen,
          "resultado": item.resultado
        };

        const put = await this.$store.dispatch('hl_put_cookie', {
          path: `ApiSuperTransporteTerminales/ActualizarAptitud-fisica/${this.examenAptitudFisica.codigoExamen}`,
          data: data
        });

        if (put.codigoError) {
          this.lanzarAlerta("warning", "¡Error al actualizar!", put.mensaje);
        } else if (put.codigoExamen) {
          this.lanzarAlerta("success", "¡Actualización exitosa!", put.mensaje);
          this.$refs.modalEditarExamenes.hide();
          // Recargar datos del paso actual
          await this.getData(this.paso);
        }
      } catch (error) {
        console.error("Error al actualizar el registro:", error);
        this.lanzarAlerta("error", "¡Error al actualizar!", error.message || error);
      }
    },

    async abrirModalEditar(item) {
      this.examenAptitudFisica = { ...item }; // Crear copia para evitar mutaciones
      this.$refs.modalEditarExamenes.show();
    },

    formatFechaISO(fecha) {
      if (!fecha) return '—';
      try {
        const date = new Date(fecha);
        if (isNaN(date.getTime())) return '—';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      } catch (error) {
        console.error('Error al formatear fecha ISO:', error);
        return '—';
      }
    },

    lanzarAlerta(tipo, titulo, texto) {
      Swal.fire({
        icon: tipo,
        title: titulo,
        text: texto,
        confirmButtonText: 'Aceptar'
      });
    }
  },
};
</script>

<style scoped>
.btn-evaluacion {
  border: solid 3px #16a275;
  transition: all 0.3s ease;
}

.btn-evaluacion:hover:not(:disabled) {
  border-color: #12d1df;
  transform: translateY(-2px);
}

.btn-evaluacion.active {
  border-color: #df122e;
  background-color: #df122e;
  color: white;
}

.btn-evaluacion:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.loading-container {
  padding: 2rem;
}

.emoji-container {
  font-size: 2rem;
  margin-bottom: 1rem;
}

.emoji {
  margin: 0 0.5rem;
  display: inline-block;
}

.animate-bounce {
  animation: bounce 2s infinite;
}

.animate-pulse {
  animation: pulse 2s infinite;
}

@keyframes bounce {

  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }

  40% {
    transform: translateY(-10px);
  }

  60% {
    transform: translateY(-5px);
  }
}

@keyframes pulse {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

.animated-row {
  transition: all 0.3s ease;
}

.animated-row:hover {
  background-color: rgba(0, 123, 255, 0.1);
}

.empty-state {
  padding: 3rem 1rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.table-responsive {
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.badge {
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
}
</style>